
import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Indicator from './indicator'
import CircularProgress from '@material-ui/core/CircularProgress';
const styles = theme => ({
  provisionalDataWarning: {
    fontSize: '11pt',
    color: '#777!important',
    fontFamily: 'Flanders Art Sans Light!important',
    textAlign: 'right',
    width: '100%',
    paddingRight: '10px',
  },
  hoverable: {
    backgroundColor: 'rgba(255,255,255,0)!important',
    '&:hover': {
      cursor: 'pointer',
    },
    minHeight: '300px',
    width: '100%',
    clear: 'none',
  },
  selectorImage: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: 0,
    minHeight: '250px',
    maxHeight: '300px',
    backgroundImage: 'url("/images/stat_icons.png")',
  },
  
  
});

function statisticsOverview(props) {
  const { classes } = props
  const statisticsData = props.statisticsData

  let provisionalDataWarning
  if (props.currentMode === 'historical') {
    if (props.yearSelected === (new Date()).getFullYear()) {

      switch (props.lang) {
        case "de":
          provisionalDataWarning = "vorläufige Zahlen"
          break;
        case "en":
          provisionalDataWarning = "Preliminary figures"
          break;
        case "fr":
          provisionalDataWarning = "Chiffres préliminaires"
          break;
        case "nl":
        default:
          provisionalDataWarning = "Voorlopige cijfers"
      }
    }
  }

  if (statisticsData === undefined)
    return <CircularProgress className={classes.progress} size={50} />
  return (

    <Grid container>
      <Grid item xs={12}>
        <Indicator
          name='energy_sum'
          value={statisticsData['energy_sum'].value}
          unit={statisticsData['energy_sum'].unit}
          //label={statisticsData['energy_sum'].label[props.lang]}
          label={statisticsData['energy_sum'].label}
        />
      </Grid>
      <Grid item xs={12}>
        <Indicator
          name='energy_as_percentage_of_demand'
          value={statisticsData['energy_as_percentage_of_demand'].value}
          unit={statisticsData['energy_as_percentage_of_demand'].unit}
          //label={statisticsData['energy_as_percentage_of_demand'].label[props.lang]}
          label={statisticsData['energy_as_percentage_of_demand'].label}
        />
      </Grid>
      < Grid item xs={12}>
        <Indicator
          name='energy_as_percentage_of_demand_peak'
          value={statisticsData['energy_as_percentage_of_demand_peak'].value}
          unit={statisticsData['energy_as_percentage_of_demand_peak'].unit}
          //label={statisticsData['energy_as_percentage_of_demand_peak'].label[props.lang]}
          label={statisticsData['energy_as_percentage_of_demand_peak'].label}
        />
      </Grid>
      <Grid item xs={12}>
        <Indicator
          name='nb_household_covered'
          value={Math.round(statisticsData['nb_household_covered'].value)}
          unit={statisticsData['nb_household_covered'].unit}
          //label={statisticsData['nb_household_covered'].label[props.lang]}        
          label={statisticsData['nb_household_covered'].label}
        />
      </Grid>

      <Grid item xs={12}>
        <Indicator
          name='co2_avoided'
          value={Math.round(statisticsData['co2_avoided'].value)}
          unit={statisticsData['co2_avoided'].unit}
          //label={statisticsData['co2_avoided'].label[props.lang]}        
          label={statisticsData['co2_avoided'].label}
        />
      </Grid>


      <p className={classes.provisionalDataWarning}>{provisionalDataWarning}</p>
    </Grid >
  );
}

statisticsOverview.propTypes = {
  classes: PropTypes.object.isRequired,
  statisticsData: PropTypes.object,
  currentMode: PropTypes.string,
  currentTech: PropTypes.object,
  yearSelected: PropTypes.number
};

export default withStyles(styles)(statisticsOverview);
